<template>
  <div
    class="trainer-combos-filter tracomfiltr f-column"
    style="gap: 1rem"
  >
    <CheckboxRow
      class="vidfitr_checkbox-rows"
      :item="ch_conf"
      style="--clr-row-back: var(--clr-black-1-2)"
      :checkboxAs="'btn'"
      :isSingle="true"
      :hasAny="false"
      @update="
        val => {
          handleCheckboxUpdate(val)
          if ($refs.PulseCircle) {
            $refs.PulseCircle.close()
          }
        }
      "
    >
      <template #default="v">
        {{ $t(`trainer.groups_selection.${v.id}`) }}
      </template>
    </CheckboxRow>
    <div
      v-if="l_groups_selection.includes('only_cd')"
      class="gw_box f-column mb-auto mr-auto text-medium b-grey clr-grey"
    >
      <div class="weight_600 text-normal clr-white">
        {{ $t('close_decisions.title') }}
      </div>
      <div
        class="mt-2"
        v-html="$t('close_decisions.text')"
      ></div>
      <div class="text-italic text-small bl-grey_2s px-2s pr-6 my-2 clr-grey">
        <div class="weight_600 mb-1">
          {{ $t('common.examples_is') }}
        </div>
        <ul
          class="f-column"
          style="gap: 0.25rem"
        >
          <li
            v-for="id in ['one', 'two', 'three']"
            :key="id"
          >
            {{ $t(`close_decisions.examples.${id}`) }}
          </li>
        </ul>
      </div>
    </div>
    <div v-else-if="l_groups_selection.includes('hand_class') && isHandClassDisabled">
      <GwMessage
        :message="{
          hide: true,
          icon: 'mdi-information',
          type: 'info',
        }"
        ><div class="truncate">Hand class training works only on Preflop / Flop.</div></GwMessage
      >
    </div>
    <div
      v-else-if="l_groups_selection.includes('hand_class')"
      class="d-flex"
      style="gap: 1rem"
    >
      <CheckboxRow
        class="cherow_grid flex-1"
        style="--columns-items-row: 1fr"
        :item="ch_hands"
        :checkboxAs="'btn'"
        :isSingle="false"
        :hasAny="true"
        @update="item => handleHandClassUpdate(item, 'hands')"
      >
        <template #default="v">
          {{ $t(`browse.filter_rules.${v.id}`) }}
        </template>
      </CheckboxRow>
      <CheckboxRow
        class="cherow_grid flex-1"
        style="--columns-items-row: 1fr"
        :item="ch_draws"
        :checkboxAs="'btn'"
        :isSingle="false"
        :hasAny="true"
        @update="item => handleHandClassUpdate(item, 'draws')"
      >
        <template #default="v">
          {{ $t(`browse.filter_rules.${v.id}`) }}
        </template>
      </CheckboxRow>
    </div>
    <CardGroupesPicker
      v-else
      ref="form"
      class="anim-fade-in"
      :groups="l_groups"
      :localKey="'trainer_combos_filter'"
      @update:groups="handleUpdate"
    >
    </CardGroupesPicker>
    <!-- </div> -->
  </div>
</template>

<script>
import CardGroupesPicker from '@/components/CardGroupesPicker/CardGroupesPicker'
import { throttle } from 'lodash'
import float_mix from '@/mixins/float_mix'
import CheckboxRow from '@/components/Forms/CheckboxRow'
import PulseCircle from '@/components/lib/PulseCircle'
import {
  getHandsCategoriesOptions,
  getDrawsCategoriesOptions,
  getGroupsSelectionOptions,
} from '@/helpers/constants'
import GwMessage from '../Messages/GwMessage.vue'

export default {
  name: 'TrainerCombosFilter',
  components: {
    CardGroupesPicker,
    CheckboxRow,
    PulseCircle,
    GwMessage,
  },
  mixins: [float_mix],
  props: {
    namespace: { String, required: true },
    autoUpdateQuery: { type: Boolean, default: true },
    routerParams: {
      default: () => ({
        push: false,
        replace: false,
        saveLocally: false,
      }),
    },
  },
  data() {
    this.commonCheckboxProps = {
      style: `--clr-disabled:var(--clr-black-3);--clr-enabled:var(--clr-white-0);--icon-size: 1.5rem;--label-size:0.875rem`,
    }
    return {
      l_groups: '',
      l_groups_selection: [],
      l_hands: [],
      l_draws: [],
    }
  },
  methods: {
    init() {
      this.l_groups_selection = [this.pref.fh_groups_selection || 'manual']
      this.l_groups = this.pref.fh_groups.split(',').filter(i => i)
      this.l_hands = this.pref.fh_hands.split(',').filter(i => i)
      this.l_draws = this.pref.fh_draws.split(',').filter(i => i)
    },
    handleHandClassUpdate(item, handClass) {
      this[`l_${handClass}`] = item.selected
      if (this.autoUpdateQuery) {
        this.apply()
      }
    },
    handleCheckboxUpdate(item) {
      this.l_groups_selection = item.selected
      if (this.autoUpdateQuery) {
        this.apply()
      }
    },
    handleUpdate: throttle(function (groups) {
      this.l_groups = groups
      if (this.autoUpdateQuery) {
        this.apply()
      }
    }, 200),
    apply() {
      const query = {
        fh_groups: this.l_groups.join(','),
        fh_groups_selection: this.l_groups_selection[0] || '',
        fh_hands: this.l_hands.join(','),
        fh_draws: this.l_draws.join(','),
      }
      this.updateQuery(query)
    },
    clear() {
      this.$refs.form.handleNumUpdate(0)
    },
    updateQuery(query) {
      const storeAction = `${this.namespace}/router_update_query`
      this.$store.dispatch(storeAction, {
        query,
        ...this.routerParams,
      })
    },
  },
  computed: {
    pref() {
      const qqfh = this.$store.getters[`${this.namespace}/query_fullhand_setup`]
      return {
        fh_groups_selection: qqfh.fh_groups_selection,
        fh_groups: qqfh.fh_groups,
        fh_hands: qqfh.fh_hands,
        fh_draws: qqfh.fh_draws,
      }
    },
    ch_conf() {
      // ['manual', 'hand_class', 'only_cd']
      const options = getGroupsSelectionOptions()
      const res = {
        id: 'hands',
        title: this.$t('common.hands'),
        title_tooltip: this.$t('trainer.groups_selection.tooltip'),
        options,
        selected: this.l_groups_selection,
      }
      return res
    },
    ch_hands() {
      const options = getHandsCategoriesOptions()
      const res = {
        id: 'hands',
        title: this.$t('common.hands'),
        title_tooltip: this.$t('trainer.groups_selection.hand_class_tooltip'),
        options,
        selected: this.l_hands,
      }
      return res
    },
    ch_draws() {
      const options = getDrawsCategoriesOptions()
      const res = {
        id: 'draws',
        title: this.$t('common.draws'),
        title_tooltip: this.$t('trainer.groups_selection.hand_class_tooltip'),
        options,
        selected: this.l_draws,
      }
      return res
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
    isHandClassDisabled() {
      // Only enable hand class selection if current spot is either preflop or flop
      return ['turn', 'river'].includes(this.$store.getters[`${this.namespace}/street`])
    },
  },
  watch: {
    pref: {
      handler: 'init',
      immediate: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.tracomfiltr {
}
</style>
